import React, { memo } from 'react';
import useShare from '../../../hooks/useShare';
import useListRates from '../../containers/ListRates/useListRates';
import Svg from '../icons/svg';

function BtnShareRates({ preparedRatesText, ...props }) {
  const { share } = useShare();
  const shareRates = () => {
    share(preparedRatesText);
  };

  return (
    <div {...props}>
      <button
        className={'w-fit btn br-c-p bc-b-c d-flex align-items-center justify-content-center'}
        type="button"
        onClick={shareRates}
      >
        <Svg name={'share'} fill={'#262626'} width={12} height={12} label={'Share'} />
      </button>
    </div>
  );
}

export default memo(BtnShareRates);
